import "styles/pages/page-media.scss";
import React from "react";
import Layout from "components/Layout";
import Seo from "components/Seo";
import SubpageHeader from "../components/SubpageHeader";
import DownloadTile from "../components/DownloadTile";
import ContactSection from "../components/ContactSection";

const MediaPage = ({ pageContext }) => {
  const seo = pageContext.seo;
  const media = pageContext.data;

  const lang = pageContext.language?.slug;
  return (
    <Layout lang={lang}>
      <Seo
        title={seo.title ? seo.title : pageContext.title}
        description={seo.metaDesc}
      />
      <SubpageHeader lang={lang} title={pageContext.title} />
      <section className="media-page">
        <div className="container">
          {media.assets.map((item, index) => {
            return (
              <div className="media-page__row" key={index}>
                <h5 className="media-page__row-title">{item.title}</h5>
                <div className="row">
                  <div className="col-lg-4">
                    <img
                      src={item.image?.sourceUrl}
                      alt={item.title}
                      className="img-fluid media-page__row-image"
                    />
                  </div>
                  <div className="col-lg-8">
                    <div className="media-page__files">
                      <div className="row">
                        {item.files.map((item, index) => {
                          return (
                            <div
                              className="col-sm-6 media-page__file"
                              key={index}
                            >
                              <DownloadTile
                                title={item.name}
                                link={item.file?.mediaItemUrl}
                                extension={item.file?.mimeType}
                                size={item.file?.fileSize}
                                lang={lang}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <ContactSection media className="media-page-contact" lang={lang} />
    </Layout>
  );
};

export default MediaPage;
